import React from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { getSurgeriesRequests } from '../../UserFunctions';


class BSTable extends React.Component {
  render() {
    if (this.props.data) {
      return (
        <BootstrapTable data={this.props.data}>
          <TableHeaderColumn dataField='urgency' width='100' isKey={true}>Urgency</TableHeaderColumn>
          <TableHeaderColumn dataField='complexity' width='115'>Complexity</TableHeaderColumn>
          <TableHeaderColumn dataField='duration' width='100'>Duration</TableHeaderColumn>
          <TableHeaderColumn dataField='cancellations' width='130'>Cancellations</TableHeaderColumn>
          <TableHeaderColumn dataField='entrance_date' width='135'>Entrance Date</TableHeaderColumn>
          <TableHeaderColumn dataField='specific_senior' width='140'>Specific Senior</TableHeaderColumn>
          <TableHeaderColumn dataField='pre_op_date' width='170'>Pre Operation Date</TableHeaderColumn>
          <TableHeaderColumn dataField='schedule_from' width='140'>Schedule From</TableHeaderColumn>
          <TableHeaderColumn dataField='schedule_deadline' width='170'>Schedule Deadline</TableHeaderColumn>
          <TableHeaderColumn dataField='description' width='140'>Description</TableHeaderColumn>
        </BootstrapTable>);
    } else {
      return (<p>?</p>);
    }
  }
}

export class SurgeriesRequests extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      requests: [],
      options: null
    }



  }

  isExpandableRow(row) {
    return true;
  }

  expandComponent(row) {
    return (
      <BSTable data={row.expand} />
    );
  }


  componentDidMount() {

    getSurgeriesRequests({ ward_id: '2' }).then(res => {
      var status_dict = {
        '1.1': 'Ready to go',
        '1.2': 'Not ready to go',
        '1.3': 'No pre operation examine date',
        '2': 'Closed',
        '3': 'Done',
        '4': 'Summoned to a surgery'
      }
      var surgery_type_dict = {
        '1': 'Discectomy',
        '2': 'Foraminitomy',
        '3': 'Arthroscopy',
        '4': 'Osteotomy',
        '12': 'Anal Fissure',
        '13': 'Bariatric',
        '14': 'Biopsy',
        '15': 'Cancer',
        '16': 'Colon',
        '17': 'Cyst',
        '18': 'Cyst',
        '19': 'Gall Bladder',
        '20': 'Hernia',
        '21': 'Hernia',
        '22': 'Piles'
      }
      var surgeries_fetched = res.data.map(surgery => {
        return {
          request_id: surgery.request_id,
          patient_id: surgery.patient_id,
          surgery_type: surgery_type_dict[surgery.surgery_type_fk],
          status: status_dict[surgery.status],
          expand: [{
            urgency: surgery.urgency,
            complexity: surgery.complexity,
            duration: surgery.duration,
            cancellations: surgery.cancellations,
            entrance_date: surgery.entrance_date,
            specific_senior: surgery.specific_senior,
            pre_op_date: surgery.pre_op_date,
            schedule_from: surgery.schedule_from,
            schedule_deadline: surgery.schedule_deadline,
            description: surgery.description
          }]
        }
      })
      console.log(surgeries_fetched)
      this.setState({ requests: surgeries_fetched })
      console.log(res);

    }).catch(err => { console.log(err) })
  }
  render() {
    return (
      <div>
        <BootstrapTable data={this.state.requests} striped hover
          sortIndicator={true}
          expandableRow={this.isExpandableRow}
          expandComponent={this.expandComponent}
          expandColumnOptions={{ expandColumnVisible: true }}>
          <TableHeaderColumn isKey={true} dataField='request_id' filter={{ type: 'TextFilter', delay: 1000 }} width='115' dataSort>Request ID</TableHeaderColumn>
          <TableHeaderColumn dataField='patient_id' width='115' filter={{ type: 'TextFilter', delay: 1000 }} dataSort>Patient ID</TableHeaderColumn>
          <TableHeaderColumn dataField='surgery_type' width='115' filter={{ type: 'TextFilter', delay: 1000 }} dataSort>Surgery Type</TableHeaderColumn>
          <TableHeaderColumn dataField='status' width='100' filter={{ type: 'TextFilter', delay: 1000 }} dataSort>Status</TableHeaderColumn>
        </BootstrapTable>,
      </div>
    )
  }
}
